document.addEventListener('DOMContentLoaded', () => {
  initializeNotFoundCarousel();
});

function initializeNotFoundCarousel() {
  const carousels = document.querySelectorAll(".js-categories-carousel");

  if (!carousels.length) return;

  if (window.innerWidth >= 992) {
    carousels.forEach((element, index) => {
      const uniqueClass = `js-categories-carousel-${String(index + 1).padStart(2, "0")}`;
      element.classList.add(uniqueClass);

      const splide = new Splide(element, {
        type     : 'slide',
        perPage  : 5,
        perMove  : 1,
        gap      : '20px',
        pagination: false,
        arrows: true,
        arrowPath: "M1 4C0.723858 4 0.5 4.22386 0.5 4.5C0.5 4.77614 0.723858 5 1 5L1 4ZM12.3536 4.85355C12.5488 4.65829 12.5488 4.34171 12.3536 4.14645L9.17157 0.964467C8.97631 0.769205 8.65973 0.769205 8.46447 0.964467C8.2692 1.15973 8.2692 1.47631 8.46447 1.67157L11.2929 4.5L8.46447 7.32843C8.2692 7.52369 8.2692 7.84027 8.46447 8.03553C8.65973 8.2308 8.97631 8.2308 9.17157 8.03553L12.3536 4.85355ZM1 4.5L1 5L12 5L12 4.5L12 4L1 4L1 4.5Z",
        breakpoints: {
          1199: {
            perPage: 4,
          },
          991: {
            perPage: 3,
          },
        }
      });

      splide.mount();
      element.splideInstance = splide;
    });
  }
}